module.exports = __webpack_public_path__ + "img/9.42420e93.svg";